(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["custom-image-with-text-overlay"] && !Shopify.designMode) return;
  try {
    const openCustomLooxReviews = () => {
    if (window.LOOX && typeof window.LOOX.openHCFloater === "function") {
      window.LOOX.openHCFloater()
      return true
    }

    const looxTrigger = document.querySelector(
      '.loox-trust-badge-container[data-loox-open-reviews="true"] .loox-trust-badge-widget-content-container'
    )

    if (looxTrigger) {
      looxTrigger.click()
      return true
    }

    return false
  }

  document.addEventListener("click", (event) => {
    const trigger = event.target.closest("[data-custom-loox-trigger]")
    if (!trigger) return

    if (openCustomLooxReviews()) return
    if (trigger.dataset.looxOpening === "true") return

    trigger.dataset.looxOpening = "true"
    let attempts = 0
    const waitForLoox = window.setInterval(() => {
      attempts += 1

      if (openCustomLooxReviews()) {
        window.clearInterval(waitForLoox)
        delete trigger.dataset.looxOpening
        return
      }

      if (attempts < 20) return

      window.clearInterval(waitForLoox)
      delete trigger.dataset.looxOpening
      if (trigger.dataset.fallbackUrl) window.location.assign(trigger.dataset.fallbackUrl)
    }, 100)
  })
  } catch(e) { console.error(e); }
})();

})();
